module.exports = __webpack_public_path__ + "static/media/icon_pulldown_a.27a52b37.svg";